export {default as data} from './index.json';
import {Component} from 'intact';
import template from './index.vdt';
import './index.styl'; 

import {bind} from 'kpc';

interface Props {
    activeAnchor?: string
}
export default class extends Component<Props> {
    static template = template;

    static defaults() {
        return {
            activeAnchor: 'config-info-card',
        }
    }
}